<template>
  <b-container fluid class="the-detail the-detail--site" v-bind:class="{'detail-visible': showDetailPage}">
    <b-row>
      <b-col class="the-detail__siteitem">
        <user-detail-head></user-detail-head>
        <b-tabs>
          <b-tab title="Basic Info">
            <user-detail-default></user-detail-default>
          </b-tab>
          <b-tab title="Account">
            <user-detail-account></user-detail-account>
          </b-tab>
          <b-tab title="Payment">
            <user-detail-payment></user-detail-payment>
          </b-tab>
        </b-tabs>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>

import { mapState } from 'vuex'

import UserDetailDefault from './UserDetailDefault'
import UserDetailAccount from './UserDetailAccount'
import UserDetailPayment from './UserDetailPayment'
import UserDetailHead from './UserDetailHead'

export default {

  name: 'UserDetail',

  components: {
    UserDetailHead,
    UserDetailDefault,
    UserDetailAccount,
    UserDetailPayment
  },

  computed: {

    ...mapState('user', [
      'userDetail',
      'showDetailPage',
      'userDetailsLoading'
    ]),

    showDetailPageDefault () {
      return this.showDetailPage
    }
  }
}
</script>
